import { createSlice } from "@reduxjs/toolkit";
import { organizationSettingsApi } from "../api/OrganizationSettingsApi";
import { organizationBrandingApi } from "../api/OrganizationBrandingApi";
import { selectRole } from "./AuthSlice";
import { resolveBranding } from "../../common/branding";

export const VERIFY_VIN_KEY = "verifyVin";
export const VERIFY_AUTO_ACCESS_KEY = "autoAccess";

const initialColor: string =
  sessionStorage.getItem("primaryColor") || resolveBranding().primaryColor;

interface OrganizationSettingsState {
  verifyVinSettingPublicId?: string;
  verifyAutoAccessPublicId?: string;
  verifyVin: boolean;
  verifyAutoAccess: boolean;
  color: string;
}

const initialState: OrganizationSettingsState = {
  color: initialColor,
  verifyVin: true,
  verifyAutoAccess: false,
};

const organizationSettingsSlice = createSlice({
  name: "organizationSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(selectRole, (state) => {
        state.color = resolveBranding().primaryColor;
      })
      .addMatcher(
        organizationSettingsApi.endpoints.getOrganizationSettings
          .matchFulfilled,
        (state, { payload }) => {
          const verifyVinSetting = payload.find(
            (state) => state.key === VERIFY_VIN_KEY
          );
          state.verifyVin = verifyVinSetting?.value === "Y";
          state.verifyVinSettingPublicId = verifyVinSetting?.publicId;
          const verifyAutoAccessSettings = payload.find(
            (state) => state.key === VERIFY_AUTO_ACCESS_KEY
          );
          state.verifyAutoAccess = verifyAutoAccessSettings?.value === "Y";
          state.verifyAutoAccessPublicId = verifyAutoAccessSettings?.publicId;
        }
      );
    builder.addMatcher(
      organizationBrandingApi.endpoints.getOrganizationBranding.matchFulfilled,
      (state, { payload }) => {
        state.color = payload.uiColorCode || initialColor;
      }
    );
  },
});

export default organizationSettingsSlice;
